// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Εμπορικό κέντρο",
        "pull_refresh": "Τραβήξτε προς τα κάτω για ανανέωση",
        "release_refresh": "Απελευθερώστε για ανανέωση",
        "refresh_loading": "Φόρτωση…",
        "footer_text": "Υπηρεσίες παρέχονται από την Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Χώρα αναζήτησης/περιοχή",
        "my_flow": "Τα δεδομένα μου",
        "charge_code": "Κώδικας κουπονιού",
        "coupons": "Κουπόνια",
        "local_package": "Τοπικά δεδομένα",
        "more": "Περισσ.",
        "popular_destination": "Χώρα/περιοχή",
        "buy_now": "Αγορά τώρα",
        "package_useing": "Ενεργός",
        "unused": "Ανενεργός",
        "download_app": "Λήψη εφαρμογής",
        "enter_the_mall_list": "Είσοδος στο εμπορικό κέντρο",
        "no_data": "Χωρίς δεδομένα",
        "no_data_available": "Δεν υπάρχουν διαθέσιμα δεδομένα",
        "copy_success": "Επιτυχής αντιγραφή",
        "copy_fail": "Αποτυχία αντιγραφής",
        "meritsTitle": "Ποια είναι τα πλεονεκτήματα？",
        "merits1": "Χωρίς απαιτούμενο SIM & Χωρίς μηνιαία χρέωση",
        "merits2": "Ενσωματωμένο με τους κορυφαίους 2-3 τελεστές για αυτόματη ανταλλαγή δικτύου.",
        "go_buy": "Αγοράστε τώρα",
        "instant_savings": "Εξοικονόμηση",
        "expires_in": "Λήγει σε",
        "download_app_tips": "Κατεβάστε την εφαρμογή για περισσότερες προσφορές και εμπειρίες"
    },
    "packages": {
        "sub_title": {
            "us": "Εξαιρουμένων του Γκουάμ, του Σαϊπάν",
            "it": "Συμπεριλαμβανομένης της πόλης του Βατικανού, του Σαν Μαρίνο",
            "va": "Συμπεριλαμβανομένης της Ιταλίας, του Σαν Μαρίνο",
            "sm": "Συμπεριλαμβανομένης της Ιταλίας, της πόλης του Βατικανού",
            "ma": "Συμπεριλαμβανομένης της δυτικής Σαχάρας",
            "eh": "Συμπεριλαμβανομένου του Μαρόκου",
            "ch": "Συμπεριλαμβανομένου του Λιχτενστάιν",
            "li": "Συμπεριλαμβανομένης της Ελβετίας",
            "fr": "Συμπεριλαμβανομένου του Μονακό",
            "mc": "Συμπεριλαμβανομένης της Γαλλίας",
            "fi": "Συμπεριλαμβανομένων των νησιών Aland",
            "ax": "Συμπεριλαμβανομένης της Φινλανδίας",
            "gu": "Συμπεριλαμβανομένων των νησιών της Βόρειας Μαρίας",
            "mp": "Συμπεριλαμβανομένου του Γκουάμ"
        },
        "unlimited_packages": "Απεριόριστο πακέτο δεδομένων",
        "normal_packages": "Κανονικό πακέτο δεδομένων",
        "multi_region_packages": "Πολυεπίπεδη περιοχή",
        "regional_data": "Περιφερειακές δεδομένα",
        "high_speed_text": "δεδομένα υψηλής ταχύτητας",
        "infiniteFlow": "Απεριόριστα δεδομένα",
        "unLimitData": "Απεριόριστο",
        "high_speed_text_year": "Υψηλή ταχύτητα/MP",
        "package_list": "Λίστα πακέτων",
        "special_offer": "Εκπτώσεις",
        "first_month": "1 Μήνας",
        "periodUnit": {
            "day": "ημέρα (ες)",
            "month": "μήνας",
            "hour": "ώρα (ες)",
            "year": "έτος"
        },
        "periodUnits": {
            "day": "ημέρα (ες)",
            "month": "μήνες",
            "hour": "ώρα (ες)",
            "year": "έτη"
        },
        "periodUnitSimp": {
            "day": "ρε",
            "month": "για",
            "hour": "H",
            "year": "ο"
        },
        "periodUnitMonthly":"Μηνιαίος",
        "periodUnitsSimp": {
            "day": "ρε",
            "month": "για",
            "hour": "H",
            "year": "ο"
        },
        "unlimited_good_name": {
            "day": "Ημερήσιο πέρασμα",
            "month": "Μηνιαία κάρτα",
            "year": "Ετήσιο πέρασμα"
        },
        "continuousMonth": "Συνεχούς μήνες",
        "continuousDay": "Συνεχείς ημέρες",
        "continuousYear": "Συνεχή έτη",
        "day_invalid": "Λήξη την τρέχουσα ημέρα",
        "month_invalid": "Λήγει στον τρέχοντα μήνα",
        "immediate_valid": "Αποτελεσματική αμέσως",
        "tomorrow_day_valid": "Αποτελεσματικό από την επόμενη μέρα",
        "tomorrow_month_valid": "Αποτελεσματικό από τον επόμενο μήνα",
        "detail": {
            "cell_flow": "Δεδομένα",
            "cell_period": "Κύρος",
            "buy_quantity": "Ποσό",
            "use_area": "Κάλυψη",
            "use_intro": "Όροι και προϋποθέσεις",
            "buy_btn": "Παραγγελία",
            "pay": "Πληρωμή",
            "buy_tips": "Έχετε το πακέτο %@packageName σε χρήση. Θέλετε να αγοράσετε αυτό το πακέτο;",
            "haveOrderTips": "Δημιουργήθηκε παραγγελία με αναμένον pagamento. Κάντε κλικ Επιβεβαίωση για να πάτε στη σελίδα δεδομένων μου！"
        },
        "confirm": {
            "title": "Παραγγελία επιβεβαίωση",
            "real_pay_amount": "Ποσό που καταβάλλεται",
            "online_payment": "Ηλεκτρονική πληρωμή",
            "create_order_error": "Η εγκατάσταση απέτυχε"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Λήψη κατάστασης παραγγελίας…",
            "buy_success": "Ολοκληρώθηκε η παραγγελία",
            "buy_pending": "Εκκρεμείς επιβεβαίωση",
            "buy_pending_tip": "Πληρωμή σε διαδικασία ... Εάν η πληρωμή δεν μεταφερθεί εντός 10 λεπτών, επικοινωνήστε μαζί μας για υποστήριξη.",
            "get_payment_info_fail": "Η απόκτηση πληροφοριών πληρωμής απέτυχε",
            "cell_package": "Πακέτο",
            "cell_buy_amount": "Υποταγμένος",
            "cell_real_amount": "Ποσό που καταβάλλεται",
            "go_to_order_btn": "Πηγαίνετε στο πακέτο μου",
            "back_home": "Επιστροφή στο σπίτι",
            "back_mall": "Επιστροφή στο εμπορικό κέντρο",
            "ordersn_empty": "Η παραγγελία SN δεν μπορεί να είναι άδειο",
            "order_search_error": "Απροσδόκητο σφάλμα",
            "goodsName": 'Όνομα προϊόντος'
        },
        "fail": {
            "payment_fail": "Απέτυχε η πληρωμή",
            "back_home": "Επιστροφή στο σπίτι"
        }
    },
    "CountryGroup": {
        "title": "Χώρα/περιοχή",
        "placeholder": "Χώρα ή περιοχή αναζήτησης",
        "clear": "Σαφής",
        "history": "Ιστορικό αναζήτησης"
    },
    "PromotionCode": {
        "verification": {
            "title": "Κώδικας κουπονιού",
            "minititle": "Κώδικας κουπονιού",
            "input": "Εισαγάγετε τον κωδικό συμπερίληψης",
            "explain": "Συμβουλές: Αγγίξτε το κουμπί σάρωσης στο επάνω δεξιά για να σαρώσετε τον κώδικα QR της κάρτας κουπονιών ή να εισαγάγετε με μη αυτόματο τρόπο τον κωδικό κουπονιού (ευαίσθητο στην περίπτωση) εάν δεν λειτουργεί.",
            "submit": "Υποτάσσομαι",
            "exchange": "Εξαργυρώνω",
            "cancel": "Ματαίωση",
            "Inquiry": "Είστε σίγουροι ότι θα ανταλλάξετε",
            "ErrorCode": "Σφάλμα κώδικα επαναφόρτισης"
        },
        "recharge_success": {
            "package": "Πακέτο",
            "content": "Με επιτυχία εξαργυρώθηκε",
            "back": "Επιστροφή στο εμπορικό κέντρο",
            "view_packets": "Πηγαίνετε στο πακέτο μου"
        }
    },
    "order": {
        "state": {
            "inUse": "Ενεργοποιημένος",
            "isFirst": "Προτεραιότητα",
            "toFirst": "Καθορισμός προτεραιότητας",
            "inactive": "Αδρανοποιημένος"
        },
        "periodUnits": {
            "minute": "πρακτικά)",
            "hour": "ώρα (ες)",
            "day": "ημέρα (ες)",
            "month": "Μήνας (ες)"
        },
        "useIntro": {
            "tip1": "Το πακέτο απεριόριστων δεδομένων έχει υψηλότερη προτεραιότητα από το πακέτο δεδομένων όγκου.",
            "tip2": "Η προτεραιότητα χρήσης θα βασίζεται στην ημερομηνία αγοράς για τον ίδιο τύπο πακέτου, δηλ. Το πακέτο με την πρώτη ημερομηνία αγοράς θα εξαντληθεί πρώτα, ενώ η προτεραιότητα των πακέτων μιας περιφέρειας είναι υψηλότερη από την περιφερειακή συσκευασία.",
            "tip3": "Μπορείτε επίσης να προσαρμόσετε με μη αυτόματο τρόπο την προτεραιότητα της χρήσης πακέτων του ίδιου τύπου."
        },
        "myFlow": "Τα δεδομένα μου",
        "remainingFlow": "Αριστερά δεδομένα",
        "remainingTime": "Ισχύει αριστερά",
        "remainingHighFlow": "Υπόλοιπο υ.τ.",
        "validPeriod": "Κύρος",
        "noneFlow": "Χωρίς πακέτο δεδομένων",
        "noneFlowTip": "Αγοράστε το πακέτο δεδομένων και απολαύστε το δίκτυο υψηλής ποιότητας",
        "buyPackFlow": "Αγοράστε πακέτα",
        "checkInvalidFlow": "Ελέγξτε το πακέτο δεδομένων που έληξε",
        "orderList": {
            "title": "τις παραγγελίες μου",
            "amount_paid": "Σύνολο",
            "device": "Ιδιόκτητη συσκευή",
            "order_details": "Στοιχεία παραγγελίας",
            "total_amont": "Υποσύνολο",
            "orderSN": "Παραγγελία αρ.",
            "createTime": "Χρόνος δημιουργίας",
            "cancelTime": "Ώρα κλειστή",
            "payTime": "Ώρα παραγγελίας",
            "unsubTime": "Ακυρωμένος χρόνος",
            "payMethod": "Τρόπος πληρωμής",
            "thirdSN": "Συναλλαγή αρ.",
            "delete": "Διαγράφω",
            "cancel": "Ακύρωση παραγγελίας",
            "unsub": "Επιστροφή χρημάτων",
            "goto_cancel": "Θέλετε να ακυρώσετε την παραγγελία;",
            "goto_unsubscribe": "Θέλετε να καταργήσετε την εγγραφή της παραγγελίας;",
            "delete_Tips": "Η παραγγελία δεν μπορεί να συνεχιστεί μετά τη διαγραφή, επομένως τα προβλήματα μετά την εξυπηρέτηση δεν μπορούν να αντιμετωπιστούν.Είστε σίγουροι ότι θα το διαγράψετε;",
            "status_success": "Ολοκληρώθηκε το",
            "status_pending": "Απλήρωτος",
            "status_cancel": "Κλειστό",
            "status_unsub": "Ακυρώθηκε",
            "payMethod_stripe": "Πιστωτική κάρτα"
          },
    },
    "registerlogin": {
        "create_account_tip":"Δημιουργήστε έναν λογαριασμό, ξεκινήστε την αποκλειστική εμπειρία",
        "select_country_tip":"Χρήση συσκευής/Περιοχή",
        "email_name": "Ταχυδρομείο",
        "phone_name": "Τηλέφωνο",
        "email_address": "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
        "password": "σύνθημα",
        "country": "χώρα",
        "select_country": "Επιλέξτε μια χώρα",
        "cancel": "Ματαίωση",
        "confirm": "Σίγουρος",
        "please_enter": "Εισαγάγετε 6-20 χαρακτήρες (συνδυασμός γραμμάτων, αριθμών ή συμβόλων)",
        "select_country_tips": "Η επιλογή της χώρας είναι για την προβολή τοπικών πακέτων. Δεν μπορεί να αλλάξει μετά την εγγραφή. Επιβεβαιώστε!",
        "global_roaming": "Διεθνής κωδικός τομέα",
        "phone_number": "αριθμός τηλεφώνου",
        "agree": "συμφωνώ",
        "user_agreement": "Συμφωνία χρήστη",
        "and": "και",
        "privacy_policy": "Πολιτική απορρήτου",
        "register_login": "Εγγραφείτε ή συνδεθείτε",
        "login_error": "Ο αριθμός των συνδέσεων είναι πολύ συχνός, δοκιμάστε ξανά αργότερα!",
        "register_error": "Ο αριθμός των εγγραφών είναι πολύ συχνός, δοκιμάστε ξανά αργότερα!",
        "forgot_pwd": "Ξεχάστε τον κωδικό πρόσβασης",
        "app_tips": "Συνδεθείτε στην εφαρμογή με αυτόν τον λογαριασμό μετά τη λήψη της για να αποκτήσετε πρόσβαση σε περισσότερες λειτουργίες.",
        "download_app": "Μεταβείτε για λήψη της εφαρμογής",
        "rememberPwd": "Θυμηθείτε τον κωδικό πρόσβασης",
        "third_login": "Συνεχίζω",
        "agreement_tips": "Ελέγξτε το πλαίσιο της Συμφωνίας Χρήστη και της Πολιτικής Απορρήτου",
        "selectCountry_tips": "Παρακαλώ σημειώστε ότι η εγγεγραμμένη χώρα θα επηρεάσει άμεσα τις ακόλουθες μεθόδους πληρωμής και νομίσματα, επιλέξτε ανάλογα με τις ανάγκες σας.",
        "login_error_cancel": "Ο χρήστης ακύρωσε την είσοδο",
        "login_error_auth": "Επιτρέψτε τα αναδυόμενα παράθυρα από τις ρυθμίσεις του προγράμματος περιήγησης",
        "device_tips": "Η συσκευή αναμένει ενεργοποίηση. Επεξεργασία σε 24 ώρες."
    },
    "forgotPwd": {
        "forgot_pwd": "Ξεχάστε τον κωδικό πρόσβασης",
        "email_address": "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
        "next": "Επόμενος",
        "email_has_been_sent": "Έχουμε στείλει ένα email στο %@email. Κάντε κλικ στο σύνδεσμο και ακολουθήστε τα βήματα για να ανακτήσετε τον κωδικό πρόσβασής σας.",
        "have_retrieved_it": "Το βρήκα",
        "unable_to_receive_email": "Δεν μπορείτε να λάβετε το email; Ελέγξτε εάν υπάρχουν μηνύματα ηλεκτρονικού ταχυδρομείου από το %@email στον κατάλογο ανεπιθύμητων μηνυμάτων και διαγραφής",
        "or": "ή",
        "resend": "Επανέρχομαι",
        "global_roaming": "Διεθνής κωδικός τομέα",
        "phone_number": "αριθμός τηλεφώνου",
        "verification_code_has_been_sent": "Έχουμε στείλει τον κωδικό επαλήθευσης σε:",
        "verification_code": "Κωδικός επαλήθευσης",
        "no_verification_code_received": "Δεν έλαβε τον κωδικό επαλήθευσης;",
        "please_enter": "Εισαγάγετε 6-20 χαρακτήρες (συνδυασμός γραμμάτων, αριθμών ή συμβόλων)",
        "reset_password": "Επαναφορά κωδικού πρόσβασης",
        "reset_successful": "Επαναφορά με επιτυχία"
    },
    "coupons": {
        "coupons_name": "Κουπόνια",
        "no_coupons": "Δεν υπάρχουν ακόμη κουπόνια",
        "no_data": "Δεν υπάρχουν ακόμη δεδομένα",
        "applicable_to_the_following": "Τα κουπόνια είναι κατάλληλα για το ακόλουθο πακέτο δεδομένων"
    },
    "digital":{
        "title":"Συσκευή SN",
        "purchased":"Οι αγορές μου",
        "viewAll":"Περισσότερο",
        "skinStore":"Αποθήκη προϊόντων",
        "completed":"Αγορασμένος",
        "goBuy":"Αγορά",
        "order": {
          "title":"Αγορασμένες παραγγελίες"
        },
        "detail": {
          "describe":"Περιγραφή"
        }
    },
    "viewPL": {
        "other": 'άλλοι'
    },
    "invalidFlow": {
        "stateName": "Κατάσταση",
        "state": {
            "NOT_ACTIVATED": "Αδρανοποιημένος",
            "IN_USING": "Διαθέσιμος",
            "USE_END": "Εξαντλημένος",
            "EXPIRE": "Έληξε",
            "TRANSFER": "Μεταφορά",
            "UNSUBSCRIBE": "Ματαίωση",
            "VALID": "Εγκυρος",
            "INVALID": "Ακυρος",
            "EXCHANGE_POINTS": "Εξαγορά σημεία"
        },
        "noneFlow": "Χωρίς πακέτο δεδομένων που έληξε",
        "pageName": "Πακέτο δεδομένων που έληξε"
    },
    "flowDetail": {
        "title": "Λεπτομέρειες δεδομένων",
        "flow": "Δεδομένα",
        "validTime": "Έγκυρες εκκινήσεις",
        "invalidTime": "Ισχύει μέχρι",
        "coverage": "Κάλυψη",
        "useIntro": "Όροι και προϋποθέσεις",
        "purchaseTime": "Αγόρασε",
        "subtotal": "Υποταγμένος",
        "status": "Κατάσταση",
        "cancel": "Ματαίωση",
        "buyAgain": "Αγοράστε ξανά",
        "validity": "Κύρος",
        "tip": "Ανακοίνωση",
        "cancelTip": "Είστε βέβαιοι ότι θέλετε να επιστρέψετε αυτό το πακέτο;",
        "dataLeft": "Αριστερά δεδομένα"
    },
    "netError": {
        "try_again": "Δοκιμάζω ξανά",
        "net_error": "Χωρίς δίκτυο",
        "try_again_desc": "Ελέγξτε τη ρύθμιση δικτύου και δοκιμάστε ξανά"
    },
    "loadFail": {
        "try_again": "Δοκιμάζω ξανά",
        "load_fail": "Η φόρτωση απέτυχε",
        "load_fail_desc": "Η φόρτωση δεδομένων απέτυχε, δοκιμάστε ξανά",
        "IMEI_Not_Exist": "Δεν υπάρχει imei, προσπαθήστε να εισέλθετε από τη σωστή είσοδο",
        "Project_Not_Exist": "Εμφανίζεται σφάλμα. Επικοινωνήστε με την εξυπηρέτηση πελατών. (01)",
        "commonError": "Εμφανίζεται σφάλμα. Επικοινωνήστε με την εξυπηρέτηση πελατών."
    },
    "settlement_Easy_and_convenient": "Εύκολο και βολικό",
    "settlement_Great_deal": "Μεγάλη προσφορά",
    "settlement_Safe_and_secure": "Ασφαλές και ασφαλές",
    "settlement_Autopay_service_regulation": "Κανονισμός υπηρεσίας αυτόματης υπηρεσίας",
    "settlement_Read": "Ανάγνωση",
    "settlement_No_coupon": "Χωρίς διαθέσιμο κουπόνι",
    "settlement_Subtotal": "Υποταγμένος",
    "settlement_Coupon": "Κουπόνι",
    "settlement_TOTAL": "Σύνολο",
    "settlement_promotion_tip": "Η διαφημιστική προσφορά δεν μπορεί να χρησιμοποιηθεί σε συνδυασμό με οποιοδήποτε κουπόνια",
    "settlement_coupon_tip": "Το κουπόνι δεν μπορεί να χρησιμοποιηθεί σε συνδυασμό με οποιεσδήποτε άλλες διαφημιστικές προσφορές",
    "member_myFlow_noList": "Χωρίς δεδομένα~",
    "detail_se_content": "Ένας ασφαλής, εύκολος και βολικός τρόπος. Μπορείτε να διαγραφείτε ανά πάσα στιγμή",
    "Enter_Promo_code": "Κώδικας προώθησης",
    "Enter_Promo_Coupon": "Κουπόνια",
    "settlement_Not_used_coupon": "Το κουπόνι δεν χρησιμοποιήθηκε",
    "settlement_Available_coupon": "Διαθέσιμος",
    "settlement_Unavailable_coupon": "Δυσεύρετος",
    "please_Enter_Promo_code": "Εισαγάγετε τον κωδικό προώθησης",
    "please_Select_Coupon_use": "Επιλέξτε το κουπόνι που θέλετε να χρησιμοποιήσετε.",
    "Buy_Now": "Αγορά τώρα",
    "Dont_Use_Any": "Μην χρησιμοποιείτε",
    "settlement_confirm": "Επιβεβαιώνω",
    "settlement_tips": "Επιβεβαιώνω",
    "flowDetail_unsubscribe": "Διαγραφώ να διαγραφούν",
    "flowDetail_unsubscribed": "Μη διαγραφής",
    "flowDetail_isCancelPackage": "Διαγραφή αυτού του πακέτου;",
    "flowDetail_confirmAgreementUnsubscribe": "Δεν μπορείτε να έχετε τα μεγάλα μετά την κατάργηση της εγγραφής. Είστε βέβαιοι ότι θέλετε να διαγραφείτε;",
    "flowDetail_cancel": "Ματαίωση",
    "flowDetail_cancelSuccess": "Μη καταργήστε την εγγραφή σας",
    "packages_detail_promotion": "Προαγωγή",
    "orderTips":{
        "iDay" : "ημέρα",
        "iDays" : "ημέρες",
        "iMonth" : "μήνας",
        "iMonths" : "μήνες",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Στην πρώτη σας αγορά, Πληρώστε %@money/%@periodSymbol αργότερα, Μπορείτε να διαγραφείτε ανά πάσα στιγμή",
        'Monthly_discount':"Αποθήκευση %@saveMoney κάθε %@period! Μπορείτε να διαγραφείτε ανά πάσα στιγμή",
        'Ordinary_monthly_package':"Ένας ασφαλής, εύκολος και βολικός τρόπος. Μπορείτε να διαγραφείτε ανά πάσα στιγμή",
        "AlreadyPurchased":'Συγγνώμη που μπορείτε να εγγραφείτε μόνο σε ένα πακέτο δεδομένων αυτή τη στιγμή. Παρακαλείσθε να καταργήσετε την εγγραφή σας από το “%@” και να εγγραφείτε αργότερα σε οποιοδήποτε πακέτο που επιθυμείτε μετά τη λήξη του.',
        "Contract_recommendation_First":'<label>Με την υπηρεσία αυτόματης χρήσης, στην πρώτη σας αγορά, πληρώστε μόνο</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Μπορείτε να διαγραφείτε ανά πάσα στιγμή'
        +'<a class="btn">Συνεισφέρω ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Με την υπηρεσία αυτόματου υπολογιστή, πληρώνουν μόνο</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Με την υπηρεσία αυτόματου υπολογιστή, πληρώνουν μόνο'
        +'<a class="btn">Συνεισφέρω ></a></p>',
        "Contract_recommendation_General":"<label>Με υπηρεσία αυτόματης</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Ένας ασφαλής, εύκολος και βολικός τρόπος. Μπορείτε να διαγραφείτε ανά πάσα στιγμή'
        +'<a href="javascript:;" class="btn">Συνεισφέρω ></a></p>',
        'BanlanceDoubleCheck':'Είστε βέβαιοι ότι θέλετε να πληρώσετε με υπόλοιπο;',
    },
    feedback: {
        title: "ανατροφοδότηση",
        placeholder: "Εισαγάγετε τη χώρα που θέλετε να επισκεφθείτε ή οποιεσδήποτε άλλες ερωτήσεις και θα ανταποκριθούμε στις ανάγκες σας το συντομότερο δυνατό!",
        submit: "Υποτάσσομαι",
        submit_success: "Υποβολή με επιτυχία",
        other_opinions: "Άλλες απόψεις",
    },
    view_country_input: 'Εισαγάγετε τον λογαριασμό σας',
    "select_package": {
        "title": "Επιλέξτε τα Δεδομένα",
        "allPackage": "Όλα τα Δεδομένα",
        "type": "Τύπος",
        "flow": "Δεδομένα",
        "month_package": "Μηνιαίο Πλάνο",
        "flow_package": "Πακέτο Δεδομένων",
        "time": "Διάρκεια",
        "period": "Κύκλος",
        "auto_debit": "Πληροφορίες Αυτοδανεισμού",
        "auto_subscribe": "Auto-Ανανέωση",
        "detail": "Λεπτομέρειες Δεδομένων",
        "carrier": "Υποστηριζόμενοι Επιχειρησιαστές",
        "country": "Χώρες Καλύπτονται",
        "notice": "Οδηγός Αγοράς"
    }
}